import {BankAccountRepository} from "./bank-account.repository";
import {BankAccountRepositoryV2} from "./bank-account.repository.v2";

export type {
  BankAccountRepository,
  InitiateUpdateParams,
} from "./bank-account.repository";
export {BankAccountRepositoryV2} from "./bank-account.repository.v2";
export {StripeRepository, isStripeOnboardResult} from "./stripe.repository";
export type {StripeOnboardResult, LoginToStripeResponse} from "./stripe.repository";

/**
 * Factory function to create the bank account repository.
 *
 * V1 has been fully decommissioned; this always returns the v2 implementation.
 */
export const createBankAccountRepository = (): BankAccountRepository => {
  return new BankAccountRepositoryV2();
};
